import { IntlShape } from "react-intl"
import {
	AGE_GROUP_FILTER,
	CATEGORY_GROUP_FILTER,
	GENDER_GROUP_FILTER,
	LOCATION_GROUP_FILTER,
	PRODUCT_GROUP_FILTER,
} from "./constants"
import {
	COUNTIES,
	FORMATS,
	REGIONS,
	STORES,
	VENDORS,
	BRANDS,
	PRODUCTS,
	CATEGORIES,
	DEPARTMENTS,
} from "components/Shared/GlobalFilter/constants"

type FilterDisplayName = {
	displayName: string
}

export const elementsPerGroupFilter: Record<string, Array<string>> = {
	[LOCATION_GROUP_FILTER]: [REGIONS, COUNTIES, FORMATS, STORES],
	[PRODUCT_GROUP_FILTER]: [VENDORS, BRANDS, PRODUCTS],
	[CATEGORY_GROUP_FILTER]: [DEPARTMENTS, CATEGORIES],
}

export const getFiltersList = (
	intl: IntlShape
): Record<string, FilterDisplayName> => {
	return {
		[LOCATION_GROUP_FILTER]: {
			displayName: intl.formatMessage({
				id: "phronesis.filters.groups.location",
			}),
		},
		[CATEGORY_GROUP_FILTER]: {
			displayName: intl.formatMessage({
				id: "phronesis.filters.groups.categories.and.department",
			}),
		},
		[PRODUCT_GROUP_FILTER]: {
			displayName: intl.formatMessage({
				id: "phronesis.filters.groups.products",
			}),
		},
		[AGE_GROUP_FILTER]: {
			displayName: intl.formatMessage({
				id: "phronesis.filters.groups.age",
			}),
		},
		[GENDER_GROUP_FILTER]: {
			displayName: intl.formatMessage({
				id: "phronesis.filters.groups.gender",
			}),
		},
	}
}
